<template>
  <div class="sub-panel-wrapper">
    <sb-panel variation="sub" class="sub-panel">
      <div>
        <h4>{{ title }}</h4>
        <slot />
      </div>
    </sb-panel>
  </div>
</template>

<script>
export default {
  name: 'HeadsUpPanel',
  components: {},
  mixins: [],
  props: {
    title: {
      type: String,
      required: false,
      default: 'Please note!'
    }
  },
  data: () => ({}),
  mounted () {},
  destroyed () {},
  watch: {},
  computed: {},
  methods: {},
  directives: {},
  filters: {},
  i18n: { messages: {} }
}
</script>

<style lang='scss'>
@import './pricing-details-panel';


</style>

